import { Box, Tooltip } from '@mui/material';
import { CONFIG_STATE, READINESS, SX } from './tokens';

/**
 * The state of a setting, shown before you open it.
 *
 * Every config screen in the module previously rendered a merchant with nothing
 * configured identically to one with everything configured -- you had to open
 * each card to find out. This chip is the fix, and it is deliberately the only
 * place the CONFIG_STATE palette is used.
 *
 * @param state  one of CONFIG_STATE keys: set | unset | inherited | attention | inactive
 * @param label  override the default label
 * @param hint   tooltip -- say *why* it is in this state, not what the state is
 */
export default function StateChip({ state = 'unset', label, hint, sx }) {
    const s = CONFIG_STATE[state] || CONFIG_STATE.unset;
    const chip = (
        <Box component="span" sx={{
            ...SX.pill,
            color: s.fg,
            bgcolor: s.bg,
            border: `1px solid ${s.border}`,
            ...sx,
        }}>
            {label || s.label}
        </Box>
    );
    return hint ? <Tooltip title={hint} arrow placement="top">{chip}</Tooltip> : chip;
}

/**
 * Readiness of one onboarding dimension for a merchant, for the Merchants list.
 * Reads from fields the merchant document already carries -- no new API.
 *
 * @param tone  done | pending | blocked | none
 */
export function ReadinessChip({ tone = 'none', label, hint }) {
    const t = READINESS[tone] || READINESS.none;
    const chip = (
        <Box component="span" sx={{
            ...SX.pill,
            color: t.fg,
            bgcolor: t.bg,
            border: `1px solid ${t.border}`,
            fontSize: 10,
            px: 0.7,
        }}>
            {label}
        </Box>
    );
    return hint ? <Tooltip title={hint} arrow placement="top">{chip}</Tooltip> : chip;
}
